import { profileConstants } from '../_constants/userProfile.constants';
const initialState =  {};
 function userProfileReducer(state = initialState, action) {
  switch (action.type) {
    case profileConstants.PROFILE_SUCCESS:
      console.log("data",action.data)
      return {
         taskId : action.taskId
         };
    default:
      return state
  }
}

export default userProfileReducer;